import React from 'react';
import Text from '../Text/Text';
import './BankAccountDetails.css';
import LabeledValue from '../LabeledValue';

interface BankAccountDetailsProps {
  accountHolderName: string;
  routingNumber: string;
  last4: string;
  bankName?: string;
  onUpdateClick: () => void;
}

const BankAccountDetails: React.FC<BankAccountDetailsProps> = ({
  accountHolderName,
  routingNumber,
  last4,
  bankName,
  onUpdateClick
}) => {
  return (
    <div className="bank-account-details-container">
      <div className="bank-account-details-header">
        <Text className="text-body">Bank Account Details</Text>
      </div>
      
      <div className="bank-account-details-content">
        <LabeledValue label='Account Holder' value={accountHolderName} rightAligned={ true } />
        <LabeledValue label='BSB' value={routingNumber} rightAligned={ true } />
        <LabeledValue label='Account Number' value={`XXXX${last4}`} rightAligned={ true } />
        {bankName && (
            <LabeledValue label='Bank' value={bankName} rightAligned={ true } />
        )}
      </div>
      
      <button
        className="bank-account-update-button"
        onClick={onUpdateClick}
      >
        Update Bank Account
      </button>
    </div>
  );
};

export default BankAccountDetails;